export enum ACTION_MODAL_TYPES {
  DEFAULT = 'DEFAULT',
  DESTRUCTIVE = 'DESTRUCTIVE'
}

export interface IActionModalProps {
  title: string;
  description?: string;
  mainButtonTitle: string;
  cancelButtonTitle: string;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  modalType?: ACTION_MODAL_TYPES;
  disclaimerText?: string;
}
